'use strict';

if (process.env.NODE_ENV === 'production') {
  module.exports = require('./cjs/scheduler.production.min.js');
} else {
  module.exports = require('./cjs/scheduler.development.js');
}



//////////////////
// WEBPACK FOOTER
// /Users/cully/projects/Jobs/abound/~/scheduler/index.js
// module id = ../../node_modules/scheduler/index.js
// module chunks = 18